export default "__VITE_ASSET__CYXSPnHD__"